// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__30tqM","content":"PrivacyPolicyPage_content__2UhyW","linkActive":"PrivacyPolicyPage_linkActive__iu2Es"};